// ** Imports createContext function
import { createContext } from "react"

// ** Init Auth userData context
export const AuthContext = createContext()

export const MobileUsersContext = createContext()

export const StretagyContext = createContext()
